import React from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATUS_COLOR = {
  PAID:     "#c084fc",
  LOCKED:   "#60a5fa",
  APPROVED: "#00ff90",
  REVIEW:   "#fbbf24",
  DRAFT:    "rgba(255,255,255,0.4)",
};

function fmt(n) {
  if (n == null) return "—";
  if (n >= 10000000) return `₹${(n/10000000).toFixed(2)}Cr`;
  if (n >= 100000)   return `₹${(n/100000).toFixed(2)}L`;
  return `₹${Number(n).toLocaleString("en-IN")}`;
}

export default function PayrollKpis({ loading, kpis }) {
  const {
    gross = 0, deductions = 0, net = 0,
    headcount = 0, processed = 0,
    runStatus = "DRAFT",
  } = kpis || {};

  const statusColor = STATUS_COLOR[runStatus] || STATUS_COLOR.DRAFT;

  const CHIPS = [
    { label: "Headcount",  value: headcount,       color: "#00ff90"    },
    { label: "Processed",  value: processed,       color: "#60a5fa"    },
    { label: "Gross Pay",  value: fmt(gross),      color: "#fbbf24"    },
    { label: "Deductions", value: fmt(deductions), color: "#f87171"    },
    { label: "Net Pay",    value: fmt(net),        color: "#00ff90"    },
    { label: "Run Status", value: runStatus,       color: statusColor  },
  ];

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        {CHIPS.map(({ label, value, color }) => (
          <div key={label} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading ? (
              <div className="h-6 rounded bg-white/10 animate-pulse mb-1" />
            ) : (
              <p className="text-lg font-bold" style={{ color }}>{value ?? "—"}</p>
            )}
            <p className="text-xs text-white/30 mt-0.5">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}